module.exports = __webpack_public_path__ + "static/img/hkfyg.b829bb61.png";